const investExpertiseAssetsSector = {
	cybersecurity: {
		tag: 'invest.expertise.assets.sector.cybersecurity',
		fr: 'Cybersécurité',
		en: 'Cybersecurity',
	},
	digital_health: {
		tag: 'invest.expertise.assets.sector.digital_health',
		fr: 'Santé numérique',
		en: 'Digital health',
	},
	foodtech: {
		tag: 'invest.expertise.assets.sector.foodtech',
		fr: 'Foodtech',
		en: 'Foodtech',
	},
	insurtech: {
		tag: 'invest.expertise.assets.sector.insurtech',
		fr: 'Insurtech',
		en: 'Insurtech',
	},
	software: {
		tag: 'invest.expertise.assets.sector.software',
		fr: 'Software',
		en: 'Software',
	},
	agritech: {
		tag: 'invest.expertise.assets.sector.agritech',
		fr: 'Agritech',
		en: 'Agritech',
	},
	mobility: {
		tag: 'invest.expertise.assets.sector.mobility',
		fr: 'Mobilité',
		en: 'Mobility',
	},
	industry: {
		tag: 'invest.expertise.assets.sector.asset_currency',
		fr: 'Industrie',
		en: 'Industry',
	},
	fintech: {
		tag: 'invest.expertise.assets.sector.fintech',
		fr: 'Fintech',
		en: 'Fintech',
	},
	others: {
		tag: 'invest.expertise.assets.sector.others',
		fr: 'Autres',
		en: 'Others',
	},
};

export default investExpertiseAssetsSector;
